import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { closeLegalCompanyModal, saveLegalCompanyModal } from '../../../actions/masters/masters'
import LegalCompanyModal from '../../../components/masters/legalCompany/LegalCompanyModal'

export function mapStateToProps (state) {
  return {
    ...state.entityMasters
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      closeLegalCompanyModal,
      saveLegalCompanyModal
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(LegalCompanyModal))
